import { JarvisUserModel } from './jarvisUserModel';
import { SedeModel } from './sedeModel';

export interface UserModel {
    nomeUtente: string
    sediAttive: Array<SedeModel>;
    id: string;
    _id?: string;
    email: string;
    name: string;
    photoUrl: string;
    firstName: string;
    lastName: string;
    funzione: string;
    roles: Array<string>;
    active?: boolean;
    lastAccess: Date;
    placeOfBirth: string;
    birthdate: string;
    lastAccessVersion: string;
    environment: string;
    jarvisUser: JarvisUserModel;
    currentStatus?: string;
    nextBooking?: any;
    status?: 'SMART_WORKING' | 'IN_OFFICE';
    syncCalendarLocation?: boolean;
}

export class UserModelClass implements UserModel {
    nomeUtente: string;
    funzione: string;
    sediAttive: Array<SedeModel>;
    id: string;
    _id?: string;
    roles: Array<string>;
    email: string;
    name: string;
    photoUrl: string;
    firstName: string;
    lastName: string;
    active?: boolean;
    lastAccess: Date;
    placeOfBirth: string;
    birthdate: string;
    lastAccessVersion: string;
    environment: string;
    jarvisUser: JarvisUserModel;
    currentStatus?: string;
    nextBooking?: any;
    status?: 'SMART_WORKING' | 'IN_OFFICE';
    syncCalendarLocation?: boolean;
}
